import React, { memo, useCallback, useMemo } from 'react';
import AddressAndScheduleSection from './AddressAndScheduleSection';

// Get the props type from AddressAndScheduleSection
type AddressAndScheduleProps = React.ComponentProps<typeof AddressAndScheduleSection> & {
  showScheduleModal?: boolean;
};

// Create a modified version of AddressAndScheduleSection that doesn't initialize ScheduleSetupModal
// unless explicitly told to do so
export const OptimizedAddressSection = memo(function OptimizedAddressSection(props: AddressAndScheduleProps) {
  const { showScheduleModal = false, ...restProps } = props;
  
  // Create a cached component reference that only renders the schedule modal
  // when showScheduleModal is true - using useCallback instead of useMemo for function component
  const ScheduleEnabledSection = useCallback(function WrappedSection(innerProps: typeof restProps) {
    return (
      <AddressAndScheduleSection 
        {...innerProps} 
        // Special prop to tell component not to initialize ScheduleSetupModal
        // FIXED: This was preventing the schedule modal from showing up
        // Now we'll always show the schedule modal when an address is selected
        __scheduleModalOptimized={false}
      />
    );
  }, []);
  
  // Prevent unnecessary re-renders by memoizing props
  const stableProps = useMemo(() => restProps, [
    restProps.selectedAddress?.id,
    restProps.weeklyDay,
    restProps.showAddressOnly,
    restProps.showScheduleOnly,
    // Only include the first item of arrays to reduce dependency changes
    restProps.selectedTimeSlots?.[0],
    restProps.selectedDate,
    restProps.isGift,
    // Include callback references but don't recreate on every render
    restProps.onClick,
    restProps.onScheduleUpdate,
  ]);
  
  return <ScheduleEnabledSection {...stableProps} />;
}); 